import { HOST } from "../constants/HostConstants";

export const userUpdate = async (user, setUser) => {
  try {
    const response = await fetch(`${HOST}/api/user/userUpdate`, {
      method: "POST",
      body: JSON.stringify({
        user_id: user.user_id,
        userId: user.user_id,
        user,
      }),
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(message || "Failed to update user");
    }

    const data = await response.json();

    const sanitizeUser = (userObj) => {
      if (!userObj || typeof userObj !== "object") return null;
      const { password, ssn, ...rest } = userObj;
      return rest;
    };

    setUser(sanitizeUser(data));
    return true;
  } catch (error) {
return false;
  }
};
